<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-07-22 13:54:33
 * @FilePath: \mrc-base-frontend\src\views\pushMessageLog\all\logdetail.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-07-22 13:58:59
-->
<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-07 14:55:46
 * @FilePath: \mrc-base-frontend\src\views\pushMessageLog\logdetail.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-07 16:51:24
-->
<template>
  <InfoDetail />
</template>
<script>
import InfoDetail from "../modules/info-detail.vue";
export default {
  components: { InfoDetail },
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
